// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_et-0";
export var fileCarousel = "_et-2";
export var removeFileButton = "_et-1";